import request from '@/src/utils/request'

/**
 * 取得寵物的歷史記錄列表（包含住宿記錄和備註）
 * @param {number} petId - 寵物ID
 * @param {object} params - 查詢參數 { page, perPage }
 * @returns {Promise} 歷史記錄列表
 */
export const getPetHistoryComments = async (petId, params = {}) => {
  const response = await request.get(`/admin/hotel/pet/${petId}/history-comments`, {
    params: {
      paginate: params.paginate !== undefined ? params.paginate : 0,
      page: params.page,
      perPage: params.perPage,
    },
  })
  return response
}

/**
 * 取得住宿訂單寵物的服務記錄列表
 * @param {string} hotelOrderId - 住宿訂單ID (UUID)
 * @param {number} petId - 寵物ID
 * @param {object} params - 查詢參數 { page, perPage }
 * @returns {Promise} 服務記錄列表
 */
export const getHotelOrderPetComments = async (hotelOrderId, petId, params = {}) => {
  const response = await request.get(`/admin/hotel/order/${hotelOrderId}/pet/${petId}/comments`, {
    params: {
      paginate: params.paginate !== undefined ? params.paginate : 0,
      page: params.page,
      perPage: params.perPage,
    },
  })
  return response
}

/**
 * 建立住宿訂單寵物的服務記錄
 * @param {string} hotelOrderId - 住宿訂單ID (UUID)
 * @param {number} petId - 寵物ID
 * @param {object} data - 服務記錄資料
 * @param {string} data.content - 服務記錄內容
 * @param {array} data.images - 圖片URL陣列
 * @param {object} data.questions - 問答資料物件
 * @param {array} data.external_files - 外部檔案陣列
 * @returns {Promise} 建立的服務記錄
 */
export const createHotelOrderPetComment = async (hotelOrderId, petId, data) => {
  const response = await request.post(`/admin/hotel/order/${hotelOrderId}/pet/${petId}/comment`, data)
  return response
}

/**
 * 更新住宿訂單寵物的服務記錄
 * @param {string} hotelOrderId - 住宿訂單ID (UUID)
 * @param {number} petId - 寵物ID
 * @param {string} commentUuid - 服務記錄UUID
 * @param {object} data - 要更新的服務記錄資料
 * @returns {Promise} 更新後的服務記錄
 */
export const updateHotelOrderPetComment = async (hotelOrderId, petId, commentUuid, data) => {
  const response = await request.patch(`/admin/hotel/order/${hotelOrderId}/pet/${petId}/comment/${commentUuid}`, data)
  return response
}

/**
 * 刪除住宿訂單寵物的服務記錄
 * @param {string} hotelOrderId - 住宿訂單ID (UUID)
 * @param {number} petId - 寵物ID
 * @param {string} commentUuid - 服務記錄UUID
 * @returns {Promise} 刪除結果
 */
export const deleteHotelOrderPetComment = async (hotelOrderId, petId, commentUuid) => {
  const response = await request.delete(`/admin/hotel/order/${hotelOrderId}/pet/${petId}/comment/${commentUuid}`)
  return response
}
